export enum FEATURE_FLAG {
  "SKILLS_API_CV_PARSER" = "SKILLS_API_CV_PARSER",
  "MESSAGE_CENTER" = "MESSAGE_CENTER",
  "CHAT_CONVERSATION_WITHOUT_CONTEXT" = "CHAT_CONVERSATION_WITHOUT_CONTEXT",
}
